import api from '../../api';

const path = '/placement';

export const addPlacementRequest = (values) => api.post(`${path}/add`, values);
export const editPlacementRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const getPlacementRequest = (id) => api.get(`${path}/get/${id}`);
export const getPlacementListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const deletePlacementRequest = (id) =>
    api.delete(`${path}/delete/${id}`);
export const updatePlacementRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);
